// @ts-nocheck

import { reduce } from 'lodash';

import { BasketItemStatuses } from '../../../types/basket';

/**
 * Return the nextState corresponding to the
 * BASKET_CLEAR_VALIDATED_AND_WAITING action
 *
 * Reset items, messages, etc..
 *
 * @param  {Object} state The actual state.
 * @return {Object}       Return the new state.
 */
const basketClearValidatedAndWaiting = (state) => ({
  ...state,
  items: reduce(
    state.items,
    (acc, item) => {
      const { status, oddId } = item;
      if (
        status !== BasketItemStatuses.VALIDATED &&
        status !== BasketItemStatuses.WAITING &&
        status !== BasketItemStatuses.REJECTED
      ) {
        acc[oddId] = item;
      }
      return acc;
    },
    {},
  ),
  traderId: undefined,
});

export default basketClearValidatedAndWaiting;
